/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Art_Field_SourceInputs */

const en_svc_integration_art_field_source = /** @type {(inputs: Svc_Integration_Art_Field_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

const lv_svc_integration_art_field_source = /** @type {(inputs: Svc_Integration_Art_Field_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avots`)
};

/**
* | output |
* | --- |
* | "Source" |
*
* @param {Svc_Integration_Art_Field_SourceInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_art_field_source = /** @type {((inputs?: Svc_Integration_Art_Field_SourceInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Art_Field_SourceInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_art_field_source(inputs)
	return en_svc_integration_art_field_source(inputs)
});